import { ColumnOptions } from '../types/column-options';
import { AmountColumn } from '../types/grid';
import { PathOfType } from '@softline/core';
import { ColumnHostRef } from '../types/refs';

export interface AmountColumnOptions<TRow extends object> extends ColumnOptions<TRow, number> {
  format?: string;
  rowGroup?: boolean;
  aggFunc?: string;
  getCurrency: (row: TRow | undefined) => string | undefined;
}

export function amountColumn<TRow extends object>(ref: ColumnHostRef<TRow>,
                                                  options: AmountColumnOptions<TRow>): AmountColumn<TRow> {
  const column: AmountColumn<TRow> = {
    ...options,
    type: 'amount',
    format: options.format ?? 'CURRENCY.SYMBOL'
  }
  ref.createColumn(column);
  return column;
}
